var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListBm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 17,
    viewBox: "0 0 11 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.70084 7.26551L6.99193 6.70118L8.84684 3.1052C8.93154 2.93725 8.96601 2.75895 8.95287 2.58441C8.93964 2.40872 8.87773 2.23165 8.7639 2.06986C8.64942 1.90712 8.48458 1.76332 8.2773 1.66013C8.06956 1.55671 7.83096 1.50003 7.58449 1.5L6.70084 7.26551ZM6.70084 7.26551L7.08778 7.76898M6.70084 7.26551L7.08778 7.76898M7.08778 7.76898L9.70706 11.1771C9.7947 11.3366 9.83626 11.5082 9.83353 11.6771C9.8306 11.8592 9.77578 12.0439 9.66544 12.214L10.5043 12.7583L9.66544 12.214C9.55447 12.385 9.38904 12.5377 9.17682 12.648C8.96413 12.7585 8.71724 12.8195 8.46147 12.8197H3.88135H3.55821M7.08778 7.76898L3.55821 12.8197M3.55821 12.8197L3.29618 13.0088M3.55821 12.8197L3.29618 13.0088M3.29618 13.0088L1.16699 14.5452V2.65675C1.16699 2.65671 1.16699 2.65667 1.16699 2.65662C1.16706 2.38222 1.28613 2.09743 1.53439 1.87166C1.78598 1.64287 2.14576 1.50006 2.53827 1.5M3.29618 13.0088L2.53827 1.5M2.53837 1.5H7.58441H2.53837ZM2.53837 1.5C2.53834 1.5 2.53831 1.5 2.53827 1.5M2.53837 1.5H2.53827",
    stroke: "black",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListBm);
export default __webpack_public_path__ + "static/media/ListBm.0e61f7b734b70cb6fd813cd7e32e3213.svg";
export { ForwardRef as ReactComponent };